import {
  ImageGenerationWidget,
  ImageGenerationWidgetImage,
  ImageGenerationWidgetInput,
} from '../model/image-widget.types';

interface V0Data {
  version?: 0;
  image?: ImageGenerationWidgetImage;
  images?: ImageGenerationWidgetImage[];
  settings?: ImageGenerationWidgetInput;
  input?: ImageGenerationWidgetInput;
}

interface V1Data {
  version?: 1;
  settings?: ImageGenerationWidgetInput;
  input?: ImageGenerationWidgetInput;
}

type DataUnion = V0Data | V1Data | ImageGenerationWidget;

function fromV0toV2(data: V0Data): ImageGenerationWidget {
  data.images = data.image ? [data.image] : [];
  delete data.image;

  if (data.settings) data.input = data.settings;
  delete data.settings;

  return {
    version: 2,
    ...data,
  } as ImageGenerationWidget;
}

function fromV1toV2(data: V1Data): ImageGenerationWidget {
  if (data.settings) data.input = data.settings;
  delete data.settings;

  return {
    version: 2,
    ...data,
  } as ImageGenerationWidget;
}

export default function normalize(data: DataUnion | string): ImageGenerationWidget {
  const parsed = typeof data === 'string' ? (JSON.parse(data) as DataUnion) : data;

  if (!parsed.version) return fromV0toV2(parsed as V0Data);
  switch (parsed.version) {
    case 1:
      return fromV1toV2(parsed);
  }

  return parsed as ImageGenerationWidget;
}
